import { Navigate, useLocation, Outlet } from 'react-router-dom';
import { isAuthenticated } from '../utils/auth';

// Route guard. Wraps protected <Route> entries — if there's no usable token
// (missing or past-expiry), the user is bounced to /login and the URL they
// were trying to reach is preserved in ?returnTo so login can send them back.
export default function RequireAuth({ children }) {
  const location = useLocation();
  if (!isAuthenticated()) {
    const returnTo = location.pathname + location.search + location.hash;
    return <Navigate to={`/login?returnTo=${encodeURIComponent(returnTo)}`} replace />;
  }
  return children ?? <Outlet />;
}
